module.exports = __webpack_public_path__ + "images/leasys_small2f237381338067ae3ef65ee9a2c5a43c.png";